




















import Vue, { PropType } from "vue";
import { Loopbaanfiche } from "../../types/NBE/Loopbaanfiche";
import ListItem from "../interface/ListItem.vue";
import ListItemFile from "../interface/ListItemFile.vue";
export default Vue.extend({
  components: { ListItemFile },
  props: {
    loopbaanFiches: {
      type: Array as PropType<Array<Loopbaanfiche>>,
    },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
});
